import { makeAutoObservable } from "mobx";

class LayoutModuleClass {
    aside = {
        isOpened: false,
        setOpened: function (value = false) {
            this.isOpened = value;
        }
    }

    constructor() {
        makeAutoObservable(this);
    }
}

export const LayoutModule = new LayoutModuleClass();
